<template>
  <div class="tx-contact module-contact-search">
    <div class="-max-width-limited">
      <div class="contact__search -decrease-width">
        <div class="search__type">
          <div class="type__country" @click="activeTab = true; clearInput()">
            <span class="heading epsilon icon-location-before" :class="{ '-active': activeTab }">
              <span v-show="mobileView">{{ $t('search.regionMobile') }}</span>
              <span v-show="!mobileView">{{ $t('search.region') }}</span>
            </span>
          </div>
          <div class="type__department" @click="activeTab = false; clearInput()">
            <span class="heading epsilon icon-message-before" :class="{ '-active': !activeTab }">
              <span v-show="mobileView">{{ $t('search.departmentMobile') }}</span>
              <span v-show="!mobileView">{{ $t('search.department') }}</span>
            </span>
          </div>
        </div>
        <div class="search_filters form">
          <div class="filters__country" v-show="activeTab">
            <div v-if="!loadingCountries" class="form-group selectbox" :class="{ '-small': Number(selectCountryValue) === 1 }">
              <div class="input">
                <select name="country" id="country" class="form-control" :class="{ '-filled': selectCountryValue }" v-model="selectCountryValue" @change="getContact()">
                  <option value="">{{ $t('search.labels.country') }}</option>
                  <option v-for="country in countries" :key="country.uid" :value="country.uid">{{ country.title }}</option>
                </select>
                <div class="input-background">
                  <label class="control-label" for="country">{{ $t('search.labels.country') }}</label>
                </div>
              </div>
            </div>
            <div v-else class="filters__country-loading"></div>
            <div class="form-group col col__b1-4" v-show="Number(selectCountryValue) === 1">
              <div class="input">
                <input type="text" name="zip" id="zip" class="form-control" :class="{ '-filled': inputZipValue }" v-model="inputZipValue" @keyup="checkZipLength()">
                <div class="input-background">
                  <label class="control-label" for="zip">{{ $t('search.labels.zip') }}</label>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!loadingDepartments" class="filters__department" v-show="!activeTab">
            <div class="form-group selectbox">
              <div class="input">
                <select name="department" id="department" class="form-control" :class="{ '-filled': selectDepartmentValue }" v-model="selectDepartmentValue" @change="getContact()">
                  <option value="">{{ $t('search.labels.department') }}</option>
                  <option v-for="department in departments" :key="department.uid" :value="department.uid">{{ department.title }}</option>
                </select>
                <div class="input-background">
                  <label class="control-label" for="department">{{ $t('search.labels.department') }}</label>
                </div>
              </div>
            </div>
          </div>
          <div v-else v-show="!activeTab" class="filters__department-loading"></div>
        </div>
      </div>
      <div v-if="contacts.length > 0 && initSearch" class="contact__results">
        <div v-if="!loadingContacts" class="results__result">
          <div class="result__card" v-for="(contact, index) in contacts" :key="contact.uid" v-show="index < shownContacts">
            <div class="card__content">
              <div v-if="contact.image" class="content__image col col__b2-4">
                <img :src="contact.image.split('|')[0]" :alt="contact.image.split('|')[1]" :title="contact.image.split('|')[2]"/>
              </div>
              <div class="content__detail col col__b1-auto col__b2-3">
                <div class="detail__name">
                  <span class="heading delta">{{ contact.name }}</span>
                </div>
                <div v-if="contact.position" class="detail__position">
                  <span class="heading epsilon">{{ contact.position }}</span>
                </div>
                <div class="detail__department">
                  <span class="heading epsilon">{{ contact.department.title }}</span>
                </div>
                <div class="detail__address" :class="{ '-mobile': mobileView }">
                  <div class="address__show icon-angle-right-after" v-show="mobileView" @click="toggleAddressActive(index)" :class="{ '-active': isAddressActive(index) }">
                    <span>{{ $t('search.address') }}</span>
                  </div>
                  <div class="address__container">
                    <span>{{ contact.street }}</span><br>
                    <span>{{ contact.zip }}</span> <span>{{ contact.city }}</span><br>
                    <span>{{ contact.country }}</span>
                  </div>
                </div>
                <div class="detail__link" v-show="!mobileView">
                  <a :href="`https://www.google.de/maps/place/${contact.street}+${contact.zip}+${contact.city}+${contact.country}`" target="_blank">{{ $t('search.linkMap') }}</a>
                </div>
              </div>
              <div class="content__contacts col col__b1-auto col__b2-4 col__b3-3">
                <div class="contacts__container" :class="{ '-mobile': mobileView }">
                  <div class="contact__show icon-angle-right-after" v-show="mobileView" @click="toggleContactActive(index)" :class="{ '-active': isContactActive(index) }">
                    <span>{{ $t('search.contact') }}</span>
                  </div>
                  <div class="main__contacts">
                    <div v-if="contact.phone" class="contacts__phone">
                      <a :href="`tel:${contact.phone}`" class="icon-phone-before"><span>{{ contact.phone }}</span></a>
                    </div>
                    <div v-if="contact.mobil" class="contacts__mobil">
                      <a :href="`tel:${contact.mobil}`" class="icon-mobile-before"><span>{{ contact.mobil }}</span></a>
                    </div>
                    <div v-if="contact.email" class="contacts__email">
                      <a :href="`mailto:${contact.email}`" class="icon-email-before"><span>{{ contact.email }}</span></a>
                    </div>
                  </div>
                </div>
                <div v-if="contact.email" class="contacts__button">
                  <a :href="`mailto:${contact.email}`" class="btn -btn-accent">{{ $t('search.buttonText') }}</a>
                </div>
              </div>
              <div class="detail__link" v-show="mobileView">
                <a :href="`https://www.google.de/maps/place/${contact.street}+${contact.zip}+${contact.city}+${contact.country}`" target="_blank">{{ $t('search.linkMap') }}</a>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="results__result -loading">
          <div class="result__card" v-for="item in 2" :key="`loading-${item}`">
            <div class="card__content">
              <div class="content__image col col__b2-4">
                <div class="loading-img"></div>
              </div>
              <div class="content__detail col col__b1-auto col__b2-3">
                <div class="detail__name">
                  <div class="loading-line"></div>
                </div>
                <div class="detail__department">
                  <div class="loading-line"></div>
                </div>
                <div class="detail__address" :class="{ '-mobile': mobileView }">
                  <div class="address__show selectbox" v-show="mobileView">
                    <span>{{ $t('search.address') }}</span>
                  </div>
                  <div class="address__container">
                    <div class="loading-line line-one"></div>
                    <div class="loading-line line-two"></div>
                    <div class="loading-line line-three"></div>
                  </div>
                </div>
                <div class="detail__link" v-show="!mobileView">
                  <div class="loading-line"></div>
                </div>
              </div>
              <div class="content__contacts col col__b1-auto col__b2-4 col__b3-3">
                <div class="contacts__container" :class="{ '-mobile': mobileView }">
                  <div class="contact__show selectbox" v-show="mobileView">
                    <span>{{ $t('search.contact') }}</span>
                  </div>
                  <div class="main__contacts">
                    <div class="contacts__phone">
                      <div class="loading-line"></div>
                    </div>
                    <div class="contacts__mobil">
                      <div class="loading-line"></div>
                    </div>
                    <div class="contacts__email">
                      <div class="loading-line"></div>
                    </div>
                  </div>
                </div>
                <div class="contacts__button">
                  <div class="loading-line"></div>
                </div>
              </div>
              <div class="detail__link" v-show="mobileView">
                <div class="loading-line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="contacts.length >= shownContacts" class="pagination__element">
        <div v-if="shownContacts < contacts.length" class="load-more__button">
          <div @click="shownContacts = contacts.length" class="btn -btn-accent">{{ $t('search.pagination.button') }}</div>
        </div>
        <div class="pagination__description">
          <p><span class="bold">{{ shownContacts }}</span> {{ $t('search.pagination.of') }} <span class="bold">{{ contacts.length }}</span> {{ $t('search.pagination.loaded') }}</p>
        </div>
        <div class="pagination__bar">
          <div class="bar__progress" :style="`width: calc(100% / ${contacts.length} * ${shownContacts})`"></div>
        </div>
      </div>
      <div class="search-hint result__no-result -centered" v-if="contacts.length === 0 && !initSearch">
        {{ $t('search.beforeResult') }}
      </div>
      <div v-if="!loadingContacts && contacts.length === 0 && initSearch" class="result__no-result">{{ $t('search.noResult') }}</div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  name: 'App',
  components: {},
  data() {
    return {
      contacts: [],
      countries: [],
      departments: [],
      apiBase: window.app.contact_search.api_base,
      selectCountryValue: window.app.contact_search.default_country || "",
      selectDepartmentValue: "",
      inputZipValue: "",
      activeTab: true,
      mobileView: false,
      activeAddressItems: [],
      activeContactItems: [],
      shownContacts: 4,
      loadingCountries: false,
      loadingDepartments: false,
      loadingContacts: false,
      initSearch: false
    }
  },
  methods: {
    getContact()
    {
      this.loadingContacts = true
      let config = {}
      let zip = {}
      if (this.selectCountryValue) {
        if (this.inputZipValue.length === 5) {
          zip = {
            contains: this.inputZipValue
          }
        }
        config = {
          params: {
            'responsibilities.uid': {
              equals: this.selectCountryValue
            },
            zip: zip
          }
        }
      }
      if (this.selectDepartmentValue) {
        config = {
          params: {
            'department.uid': {
              equals: this.selectDepartmentValue
            }
          }
        }
      }
      Axios.get(this.apiBase + 'contact/', config)
        .then((response) => {
          this.contacts = response.data
          this.loadingContacts = false
          this.initSearch = true
        })
        .catch((error) => {
          error.message
        })
    },
    getCountry()
    {
      this.loadingCountries = true
      Axios.get(this.apiBase + 'country/')
        .then((response) => {
          this.countries = response.data
          this.loadingCountries = false

          if (this.selectCountryValue) {
            this.activeTab = true
            this.getContact()
          }
        })
        .catch((error) => {
          error.message
        })
    },
    getDepartment()
    {
      this.loadingDepartments = true
      Axios.get(this.apiBase + 'department/')
        .then((response) => {
          this.departments = response.data
          this.loadingDepartments = false
        })
        .catch((error) => {
          error.message
        })
    },
    checkZipLength() {
      const zipRegex = /^\d{5}$/
      const zipRegexEmpty = /^\d{0}$/
      if (zipRegex.test(this.inputZipValue)) {
        this.getContact();
      } else if (zipRegexEmpty.test(this.inputZipValue)) {
        this.getContact();
      }
    },
    clearInput()
    {
      if (this.activeTab) {
        this.selectDepartmentValue = ""
      } else {
        this.selectCountryValue = ""
        this.inputZipValue = ""
      }
    },
    checkViewport()
    {
      const viewportWidth = window.innerWidth
      this.mobileView = viewportWidth < 640
    },
    toggleAddressActive(index) {
      if (this.isAddressActive(index)) {
        this.activeAddressItems = this.activeAddressItems.filter(itemIndex => itemIndex !== index)
      } else {
        this.activeAddressItems.push(index)
      }
    },
    isAddressActive(index) {
      return this.activeAddressItems.includes(index)
    },
    toggleContactActive(index) {
      if (this.isContactActive(index)) {
        this.activeContactItems = this.activeContactItems.filter(itemIndex => itemIndex !== index)
      } else {
        this.activeContactItems.push(index)
      }
    },
    isContactActive(index) {
      return this.activeContactItems.includes(index)
    },
  },
  mounted() {
    this.getCountry()
    this.getDepartment()
    this.checkViewport()
    window.addEventListener('resize', this.checkViewport)
  }
}
</script>
